import React, { PropsWithChildren } from 'react'

import './index.scss'
import ExpandableTableRow from '@Components/ViewWork/Table/TableExpandedRow'
import clsx from 'clsx'
import { TableRowData } from '@Components/ViewWork/Table'

interface BodyProps {
    rows: TableRowData[]
    removableCells?: boolean
    onRemoveCellClicked?: (index: number, removeCellIdentifier?: string) => void
}

const TableBody = ({ rows, removableCells, onRemoveCellClicked }: PropsWithChildren<BodyProps>) => (
    <>
        {rows.map((tableRow, index) => (
            <ExpandableTableRow
                className={clsx(tableRow.className, index === rows.length - 1 && 'last-row')}
                tableRow={tableRow}
                removableCells={removableCells}
                onRemoveCellClicked={(removeCellIdentifier) => {
                    onRemoveCellClicked && onRemoveCellClicked(index, removeCellIdentifier)
                }}
                key={`${tableRow.name}-${index}`}
            />
        ))}
    </>
)

export default TableBody
